const numberFormatter = new Intl.NumberFormat('fr-FR');
const compactNumberFormatter = new Intl.NumberFormat('fr-FR', {
  maximumFractionDigits: 1,
  notation: 'compact',
});

export function formatCurrencyEur(amount: number) {
  const safeAmount = Number.isFinite(amount) && amount > 0 ? amount : 0;
  const fractionDigits = safeAmount >= 1 ? 2 : 4;

  return new Intl.NumberFormat('fr-FR', {
    currency: 'EUR',
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
    style: 'currency',
  }).format(safeAmount);
}

export function formatNumber(value: number | null | undefined) {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return '0';
  }
  return numberFormatter.format(value);
}

export function formatCompactNumber(value: number | null | undefined) {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return '0';
  }
  return compactNumberFormatter.format(value);
}

export function formatDate(value: string | null | undefined) {
  if (!value) {
    return '—';
  }
  return new Date(value).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDateTime(value: string | null | undefined) {
  if (!value) {
    return '—';
  }
  return new Date(value).toLocaleString('fr-FR', {
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export function formatDeltaPct(value: number | null) {
  if (value === null || !Number.isFinite(value)) {
    return '—';
  }
  const sign = value >= 0 ? '+' : '';
  return `${sign}${value.toFixed(1)} %`;
}
